interface ExpandedAllBookedWarnIconProps {
  width?: number;
  height?: number;
  className?: string;
  primaryColor: string;
  errorColor: string;
  whiteColor: string;
}

export default function ExpandedAllBookedWarnIcon({
  width = 24,
  height = 24,
  className,
  errorColor,
  whiteColor,
}: ExpandedAllBookedWarnIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_7867_145119)">
        <g transform="matrix(1,0,0,1,-0.833496,5.0332)">
          <path
            d="M0.833,6.667L6.667,6.667L6.667,0.833L0.833,0.833L0.833,6.667ZM9.584,24.167L15.417,24.167L15.417,18.334L9.584,18.334L9.584,24.167ZM0.833,24.167L6.667,24.167L6.667,18.334L0.833,18.334L0.833,24.167ZM0.833,15.417L6.667,15.417L6.667,9.584L0.833,9.584L0.833,15.417ZM9.584,15.417L15.417,15.417L15.417,9.584L9.584,9.584L9.584,15.417ZM18.334,0.833L18.334,6.667L24.167,6.667L24.167,0.833L18.334,0.833ZM9.584,6.667L15.417,6.667L15.417,0.833L9.584,0.833L9.584,6.667ZM18.334,15.417L24.167,15.417L24.167,9.584L18.334,9.584L18.334,15.417ZM18.334,24.167L24.167,24.167L24.167,18.334L18.334,18.334L18.334,24.167Z"
            fill={errorColor}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_7867_145119">
          <rect width="30" height="30" fill={whiteColor} />
        </clipPath>
      </defs>
    </svg>
  );
}
